import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLayoutEffect, useEffect, useState } from "react";
import publicRoutes from "./pages/publicRoutes";
import runAxiosSetup from "./helper/axiosSetup";
import Dashboard from "./pages/Dashboard/Dashboard";
import Pagenotfound from "./services/PagenotFound";
import Products from "./pages/Products/Products";
import CreateUpdateProducts from "./pages/Products/CreateUpdateProducts";
import ViewProducts from "./pages/Products/ViewProducts";
import Category from "./pages/Category/Category";
import CreateUpdateCategory from "./pages/Category/CreateUpdateCategory";
import ViewCategory from "./pages/Category/ViewCategory";
import SubCategory from "./pages/SubCategory/SubCategory";
import CreateUpdateSubCategory from "./pages/SubCategory/CreateUpdateSubCategory";
import ViewSubCategory from "./pages/SubCategory/ViewSubCategory";
import Banners from "./pages/Banners/Banners";
import CreateUpdateBanners from "./pages/Banners/CreateUpdateBanners";
import ViewBanners from "./pages/Banners/ViewBanners";
import ViewBrands from "./pages/Brands/ViewBrands";
import CreateUpdateBrands from "./pages/Brands/CreateUpdateBrands";
import Brands from "./pages/Brands/Brands";
import ViewTestimonials from "./pages/Testimonials/ViewTestimonials";
import CreateUpdateTestimonials from "./pages/Testimonials/CreateUpdateTestimonials";
import Testimonials from "./pages/Testimonials/Testimonials";
import Enquiries from "./pages/Enquires/Enquiries";
import CreateUpdateEnquiries from "./pages/Enquires/CreateUpdateEnquiries";
import ViewEnquiries from "./pages/Enquires/ViewEnquiries";
import Blogs from "./pages/Blogs/Blogs";
import ViewBlogs from "./pages/Blogs/ViewBlogs";
import CreateUpdateBlogs from "./pages/Blogs/CreateUpdateBlogs";
import Orders from "./pages/Orders/Orders";
import ViewOrders from "./pages/Orders/ViewOrders";
import CreateUpdateOrders from "./pages/Orders/CreateUpdateOrders";
import CreateUpdatePayments from "./pages/PaymentsManage/CreateUpdatePayments";
import PaymentsManage from "./pages/PaymentsManage/PaymentsManage";
import ViewPayments from "./pages/PaymentsManage/ViewPayments";
import ManageReviews from "./pages/ManageReviews/ManageReviews";
import CreateUpdateReview from "./pages/ManageReviews/CreateUpdateReview";
import ViewReviews from "./pages/ManageReviews/ViewReviews";
import ManageOrderTracking from "./pages/ManageOrderTracking/ManageOrderTracking";
import ViewOrderTracking from "./pages/ManageOrderTracking/ViewOrderTracking";
import CreateUpdateOrderTracking from "./pages/ManageOrderTracking/CreateUpdateOrderTracking";
import ManageClients from "./pages/ManageClients/ManageClients";
import CreateUpdateClients from "./pages/ManageClients/CreateUpdateClients";
import ViewClients from "./pages/ManageClients/ViewClients";
import ManageVideoCollection from "./pages/ManageVideoCollection/ManageVideoCollection";
import CreateUpdateVideoCollection from "./pages/ManageVideoCollection/CreateUpdateVideoCollection";
import ViewVideoCollection from "./pages/ManageVideoCollection/ViewVideoCollection";
import ContactUs from "./pages/ContactUs/ConactUs";
import ViewContactUs from "./pages/ContactUs/ViewContactUs";
import CreateUpdateContactUs from "./pages/ContactUs/CreateUpdateContactUs";
import ViewAllCartData from "./pages/ManageAllCartData/ViewAllCartData";
import ManageAllCartData from "./pages/ManageAllCartData/ManageAllCartData";
import ViewAllWishlistData from "./pages/ManageAllWishlistData/ViewAllWishlistData";
import ManageAllWishlistData from "./pages/ManageAllWishlistData/ManageAllWishlistData";

function App() {
  const { saller, token, isAuthenticated } = useSelector(
    (state) => state?.auth || {}
  );
  const [privateRoutes, setPrivateRoutes] = useState([]);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    runAxiosSetup({
      apiUrl: process.env?.REACT_APP_API_URL,
      bearerToken: token || "",
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        userId: saller?.id || "",
      },
    });
  }, [saller, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      setPrivateRoutes([
        { path: "/", component: <Dashboard /> }, //route for dashboard

        //All Products Routes
        { path: "/products", component: <Products /> }, //route for products
        { path: "/add-new-products", component: <CreateUpdateProducts /> }, //route for products
        {
          path: "/update-new-products/:uuid",
          component: <CreateUpdateProducts />,
        }, //route for products
        { path: "/view-products/:uuid", component: <ViewProducts /> }, //route for products

        //All Categry Routes
        { path: "/category", component: <Category /> }, //route for Categry
        { path: "/add-new-categry", component: <CreateUpdateCategory /> }, //route for Categry
        {
          path: "/update-new-categry/:uuid",
          component: <CreateUpdateCategory />,
        }, //route for Categry
        { path: "/view-categry/:uuid", component: <ViewCategory /> }, //route for Categry

        //All SubCategry Routes
        { path: "/sub-category", component: <SubCategory /> }, //route for SubCategry
        {
          path: "/add-new-sub-category",
          component: <CreateUpdateSubCategory />,
        }, //route for SubCategry
        {
          path: "/update-new-sub-category/:uuid",
          component: <CreateUpdateSubCategory />,
        }, //route for SubCategry
        { path: "/view-sub-category/:uuid", component: <ViewSubCategory /> }, //route for SubCategry

        //All banners Routes
        { path: "/banners", component: <Banners /> }, //route for banners
        {
          path: "/add-new-banner",
          component: <CreateUpdateBanners />,
        }, //route for banners
        {
          path: "/update-new-banner/:uuid",
          component: <CreateUpdateBanners />,
        }, //route for banners
        { path: "/view-banner/:uuid", component: <ViewBanners /> }, //route for banners

        //All brands Routes
        { path: "/brands", component: <Brands /> }, //route for Brands
        {
          path: "/add-new-brands",
          component: <CreateUpdateBrands />,
        }, //route for Brands
        {
          path: "/update-new-brands/:uuid",
          component: <CreateUpdateBrands />,
        }, //route for Brands
        { path: "/view-brands/:uuid", component: <ViewBrands /> }, //route for Brands

        //All testimonials Routes
        { path: "/testimonials", component: <Testimonials /> }, //route for testimonials
        {
          path: "/add-new-testimonials",
          component: <CreateUpdateTestimonials />,
        }, //route for testimonials
        {
          path: "/update-new-testimonials/:uuid",
          component: <CreateUpdateTestimonials />,
        }, //route for Brands
        { path: "/view-testimonials/:uuid", component: <ViewTestimonials /> }, //route for testimonials

        //All enquiries Routes
        { path: "/enquiries", component: <Enquiries /> }, //route for enquiries
        {
          path: "/add-new-enquiries",
          component: <CreateUpdateEnquiries />,
        }, //route for enquiries
        {
          path: "/update-new-enquiries/:uuid",
          component: <CreateUpdateEnquiries />,
        }, //route for enquiries
        { path: "/view-enquiries/:uuid", component: <ViewEnquiries /> }, //route for enquiries

        //All conactus Routes
        { path: "/conactus", component: <ContactUs /> }, //route for enquiries
        {
          path: "/add-new-conactus",
          component: <CreateUpdateContactUs />,
        }, //route for enquiries
        {
          path: "/update-new-conactus/:uuid",
          component: <CreateUpdateContactUs />,
        }, //route for enquiries
        { path: "/view-conactus/:uuid", component: <ViewContactUs /> }, //route for enquiries

        //All blogs Routes
        { path: "/blogs", component: <Blogs /> }, //route for blogs
        {
          path: "/add-new-blogs",
          component: <CreateUpdateBlogs />,
        }, //route for blogs
        {
          path: "/update-new-blogs/:uuid",
          component: <CreateUpdateBlogs />,
        }, //route for blogs
        { path: "/view-blogs/:uuid", component: <ViewBlogs /> }, //route for blogs

        //All Orders Routes
        { path: "/orders", component: <Orders /> }, //route for Orders
        {
          path: "/add-new-orders",
          component: <CreateUpdateOrders />,
        }, //route for Orders
        {
          path: "/update-new-orders/:uuid",
          component: <CreateUpdateOrders />,
        }, //route for Orders
        { path: "/view-orders/:uuid", component: <ViewOrders /> }, //route for Orders

        //All payments Routes
        { path: "/payments", component: <PaymentsManage /> }, //route for payments
        {
          path: "/add-new-payments",
          component: <CreateUpdatePayments />,
        }, //route for payments
        {
          path: "/update-new-payments/:uuid",
          component: <CreateUpdatePayments />,
        }, //route for payments
        { path: "/view-payments/:uuid", component: <ViewPayments /> }, //route for payments

        //All reviews Routes
        { path: "/reviews", component: <ManageReviews /> }, //route for reviews
        {
          path: "/add-new-reviews",
          component: <CreateUpdateReview />,
        }, //route for reviews
        {
          path: "/update-new-reviews/:uuid",
          component: <CreateUpdateReview />,
        }, //route for reviews
        { path: "/view-reviews/:uuid", component: <ViewReviews /> }, //route for reviews

        //All order-tracking Routes
        { path: "/order-tracking", component: <ManageOrderTracking /> }, //route for order-tracking
        {
          path: "/add-new-order-tracking",
          component: <CreateUpdateOrderTracking />,
        }, //route for order-tracking
        {
          path: "/update-new-order-tracking/:tracking_number",
          component: <CreateUpdateOrderTracking />,
        }, //route for order-tracking
        {
          path: "/view-order-tracking/:tracking_number",
          component: <ViewOrderTracking />,
        }, //route for order-tracking

        //All clients Routes
        { path: "/clients", component: <ManageClients /> }, //route for clients
        {
          path: "/add-new-clients",
          component: <CreateUpdateClients />,
        }, //route for clients
        {
          path: "/update-new-clients/:uuid",
          component: <CreateUpdateClients />,
        }, //route for clients
        { path: "/view-clients/:uuid", component: <ViewClients /> }, //route for clients

        //All video collection Routes
        { path: "/video-collection", component: <ManageVideoCollection /> }, //route for video collection
        {
          path: "/add-new-video-collection",
          component: <CreateUpdateVideoCollection />,
        }, //route for video collection
        {
          path: "/update-new-video-collection/:uuid",
          component: <CreateUpdateVideoCollection />,
        }, //route for video collection
        {
          path: "/view-video-collection/:uuid",
          component: <ViewVideoCollection />,
        }, //route for video collection

        //All cart data Routes
        { path: "/cart-collection", component: <ManageAllCartData /> }, //route for cart collection
        {
          path: "/view-cart-collection/:uuid",
          component: <ViewAllCartData />,
        }, //route for cart collection

        //All wishlist data Routes
        { path: "/wishlist-collection", component: <ManageAllWishlistData /> }, //route for video collection
        {
          path: "/view-wishlist-collection/:uuid",
          component: <ViewAllWishlistData />,
        }, //route for video collection
      ]);
    } else {
      setPrivateRoutes([]);
    }
  }, [isAuthenticated, navigate]);

  return (
    <Routes>
      {isAuthenticated ? (
        <>
          {privateRoutes?.map((data, index) => (
            <Route path={data.path} element={data.component} key={index} />
          ))}
          <Route path="/" element={<Dashboard />} />
          <Route path="*" element={<Pagenotfound />} />
        </>
      ) : (
        <>
          {publicRoutes?.map((data, index) => (
            <Route path={data.path} element={data.component} key={index} />
          ))}
          <Route path="*" element={<Navigate replace to="/login" />} />
        </>
      )}
    </Routes>
  );
}
export default App;
